interface ErrorData {
  code: string;
  message: string;
}

export class AuthAPIError extends Error {
  constructor(message?: string) {
    super(message || 'An unknown error occurred.');
    Object.setPrototypeOf(this, AuthAPIError.prototype);
  }
}

export class AlreadyConfirmedError extends AuthAPIError {
  constructor(message?: string) {
    super(message || 'That user has already been confirmed.');
  }
}
export class CodeMismatchError extends AuthAPIError {
  constructor(message?: string) {
    super(message || 'Invalid verification code provided, please try again.');
  }
}
export class CodeExpiredError extends AuthAPIError {
  constructor(message?: string) {
    super(message || 'Your confirmation code has expired. Please go back and log in again.');
  }
}
export class TooManyAttemptsError extends AuthAPIError {
  constructor(message?: string) {
    super(message || "You're doing that too much. Please wait a while and try again.");
  }
}
export class InvalidParameterError extends AuthAPIError {}
export class InvalidPasswordError extends AuthAPIError {}
export class NotAuthorizedError extends AuthAPIError {
  constructor(message?: string) {
    super(message || 'Incorrect username or password.');
  }
}
export class PasswordResetRequiredError extends AuthAPIError {}
export class UsernameExistsError extends AuthAPIError {}
export class UserNotConfirmedError extends AuthAPIError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, UserNotConfirmedError.prototype);
  }
}
export class UserNotFoundError extends AuthAPIError {
  constructor(message?: string) {
    super(message || 'That user does not exist.');
  }
}
export class UnknownError extends AuthAPIError {}

const getPasswordError = (err: ErrorData): AuthAPIError | void => {
  if (err.code === 'InvalidPasswordException') {
    const passwordPolicyMatch = err.message.match(/Password did not conform with policy: (.*)/);
    if (passwordPolicyMatch) {
      return new InvalidPasswordError(passwordPolicyMatch[1]);
    }
    return new InvalidPasswordError(err.message);
  }
};

export const getResponseError = (
  originalError: ErrorData | string,
  errorMap: {
    [code: string]: ((err: ErrorData) => AuthAPIError) | AuthAPIError;
  }
): AuthAPIError => {
  if (originalError instanceof AuthAPIError) {
    return originalError;
  }
  // Normalize the error, since amplify can throw strings.
  const err = typeof originalError === 'string' ? { code: 'UnknownException', message: originalError } : originalError;
  const mapped = errorMap[err.code];
  return (
    getPasswordError(err) ||
    (typeof mapped === 'function' && mapped(err)) ||
    (mapped instanceof AuthAPIError && mapped) ||
    new UnknownError()
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/authClient/errors.ts